<template>
  <Button
    label="Changes History"
    icon="pi pi-info-circle"
    class="p-button-help p-button-sm"
    @click="onShowModal"
  />

  <CustomSidebar
    v-model:visible="showModal"
    position="bottom"
    :dismissable="false"
    title="Changes History"
    class="p-1"
    :blocked="blocked"
  >
    <template #actions>
      <!-- <Button icon="pi pi-save" class="p-button-sm p-button-success mr-1" :label="$t('assign_to_driver')" @click="save()"></Button> -->
    </template>

    <div class="flex" style="width: calc(100% - 2rem)">
      <div class="col-12 md-12 p-fluid">
        <DataTable
          ref="dt"
          responsiveLayout="scroll"
          class="p-datatable-sm"
          filterDisplay="row"
          sortMode="multiple"
          removableSort
          stateStorage="local"
          :stateKey="stateKey"
          :value="dataModel"
          :loading="!dataModel || loading"
          :paginator="true"
          :rows="10"
          :lazy="true"
          v-model:first="this.start"
          @state-restore="onStateRestore($event)"
          @page="onPage($event)"
          @sort="onSort($event)"
          @filter="onFilter($event)"
          v-model:filters="filters"
          :totalRecords="totalRecords"
          dataKey="Id"
          :metaKeySelection="false"
          showGridlines
        >
          <Column
            :exportable="false"
            :sortable="false"
            headerStyle="white-space:nowrap"
          >
            <template #header="">
              <!-- <Button :label="$t('create')" icon="pi pi-plus"
                            class="p-button-primary p-button-sm" @click="initWork(this.$FORM_MODE_CREATE, 0)" /> -->
            </template>
            <template #filter>
              <Button
                :label="$t('clear')"
                icon="pi pi-filter-slash"
                class="p-button-outlined p-button-primary p-button-sm"
                @click="clearFilter"
                :badge="filterBadge"
                badgeClass="p-badge-danger"
              />
            </template>
          </Column>
          <Column
            field="PermitNumber"
            :header="$t('permit_number')"
            :sortable="true"
            v-if="this.type == 'Permit'"
          >
            <template #filter="{ filterModel, filterCallback }">
              <InputText
                type="text"
                :placeholder="$t('permit_number')"
                v-if="filterModel"
                v-model="filterModel.value"
                @keydown.enter="filterCallback()"
                class="p-column-filter p-inputtext-sm"
              />
            </template>
          </Column>
          <Column
            field="WorkNumber"
            :header="$t('work_number')"
            :sortable="true"
            v-if="this.type == 'Work'"
          >
            <template #filter="{ filterModel, filterCallback }">
              <InputText
                type="text"
                :placeholder="$t('work_number')"
                v-if="filterModel"
                v-model="filterModel.value"
                @keydown.enter="filterCallback()"
                class="p-column-filter p-inputtext-sm"
              />
            </template>
          </Column>
          <Column field="CompanyCode" :header="$t('company')" :sortable="true">
            <template #filter="{ filterModel, filterCallback }">
              <InputText
                type="text"
                :placeholder="$t('Company Code')"
                v-if="filterModel"
                v-model="filterModel.value"
                @keydown.enter="filterCallback()"
                class="p-column-filter p-inputtext-sm"
              />
            </template>
          </Column>
          <Column field="ActionRole" :header="$t('role')" :sortable="true">
            <template #filter="{ filterModel, filterCallback }">
              <InputText
                type="text"
                :placeholder="$t('role')"
                v-if="filterModel"
                v-model="filterModel.value"
                @keydown.enter="filterCallback()"
                class="p-column-filter p-inputtext-sm"
              />
            </template>
          </Column>
          <Column field="Notes" :header="$t('note')" :sortable="true">
            <template #filter="{ filterModel, filterCallback }">
              <InputText
                type="text"
                :placeholder="$t('note')"
                v-if="filterModel"
                v-model="filterModel.value"
                @keydown.enter="filterCallback()"
                class="p-column-filter p-inputtext-sm"
              />
            </template>
          </Column>
          <Column
            field="ActionDate"
            :header="$t('created_date')"
            dataType="date"
            :sortable="true"
          >
            <template #filter="{ filterModel, filterCallback }">
              <Calendar
                inputMask="99/99/9999"
                momentFormat="DD/MM/YYYY"
                class="p-column-filter p-inputtext-sm"
                v-if="filterModel"
                v-model="filterModel.value"
                @keydown.enter="filterCallback()"
                @date-select="filterCallback()"
                placeholder=" Created Date"
              />
            </template>
            <template #body="{ data }">
              {{ this.$formatDateTime(data.ActionDate) }}
            </template>
          </Column>

          <Column field="ActionBy" :header="$t('created_by')" :sortable="true">
            <template #filter="{ filterModel, filterCallback }">
              <InputText
                type="text"
                v-if="filterModel"
                v-model="filterModel.value"
                @keydown.enter="filterCallback()"
                class="p-column-filter p-inputtext-sm"
                placeholder=" Created By"
              />
            </template>
          </Column>
        </DataTable>
      </div>
    </div>
  </CustomSidebar>
</template>
<script>
// import ModalDataSAPOrder from '../Helper/_ModalDataSAPOrder.vue'
// import ShowOrder from '../Helper/_ShowOrder.vue'
import { ref, watch } from "vue";
export default {
  // components: {
  //     'ModalDataSAPOrder': ModalDataSAPOrder,
  //     'ShowOrder': ShowOrder
  // },
  emits: ["close"],
  props: {
    data: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      dataModel: null,
      loading: true,
      totalRecords: 0,
      start: 0,
      stateKey:
        this.$STATE_NAME + "permitlog-" + this.$store.getters.getUsername,
      role: this.$store.getters.getRole,
      isAdmin: this.$store.getters.getIsAdmin,
      isUser: this.$store.getters.getIsUser,
      isTransporter: this.$store.getters.getIsTransporter,
      isDriver: this.$store.getters.getIsDriver,
      companyUser: this.$store.getters.getCompanyCode,
      username: this.$store.getters.getUsername,
      sorts: null,
      lazyParams: {},
      filters: null,
      workData: null,
      stateFilters: null,
      showModal: false,
      methodExecuted: false,
      showFilter: false,
      isIndividual: false,
      isCollective: false,
      isRelation: false,
      driverModels: [],
      orderData: null,
      orderShipmentData: null,
      driverModel: null,
      dataUrlPermit: "permit/list_changes_history",
      dataUrlWork: "work/list_changes_history",
      editorPath: "/Permit/Editor",
      blocked: false,
      transporter: "",
      location: "",
      selectedRow: null,
    };
  },
  methods: {
    reset() {
      this.orderData = null;
      this.driverModel = null;
      this.driverTruckModel = null;
      this.driverModels = [];
      this.isRelation = false;
      this.isIndividual = false;
      this.isCollective = false;
      this.transporter = "";
      this.location = "";

      this.orderShipmentData = null;
    },
    onShowModal() {
      this.showModal = true;
      this.loading = true;
      this.selectedRow = null;
      this.blocked = true;

      this.lazyParams = {
        start: this.start,
        sorts: this.dataSort,
        filters: this.dataFilter,
        category: this.data,
      };

      var urlLog = "";
      if (this.type == "Permit") {
        urlLog = this.dataUrlPermit;
      } else {
        urlLog = this.dataUrlWork;
      }

      var self = this;

      this.$axios
        .post(this.$API_URL + urlLog, this.lazyParams)
        .then((response) => {
          if (response.data.success) {
            //console.log(response.data.data)
            self.dataModel = response.data.data;
            self.totalRecords = response.data.totalRecords;
          } else {
            self.$toast.add({
              severity: "error",
              summary: "Error",
              detail: response.data.message,
              life: 3000,
            });
          }
          self.blocked = false;
          self.loading = false;
          self.showFilter = true;
        })
        .catch(function (err) {
          self.$toast.add({
            severity: "error",
            summary: "Error",
            detail: err.message,
            life: 3000,
          });
          self.loading = false;
          self.blocked = false;
        });
    },
    onPage(event) {
      this.start = event.first;
      this.onShowModal();
    },
    onSort(event) {
      this.sorts = event.multiSortMeta;
      this.onShowModal();
    },
    onFilter() {
      this.onShowModal();
    },
    onSelect(event) {
      this.selectedRow = event.data;
    },
    onRowExpand(event) {
      this.expandedRows = [];
      this.expandedRows.push(event.data);
    },
    editor(mode, id, status) {
      this.$router.push({
        path: this.editorPath,
        query: { mode: mode, id: id, status: status },
      });
    },
    filter(mode) {
      this.$router.push({ path: this.filterPath, query: { mode: mode } });
    },
    sidebarMessage(event) {
      this.$toast.add(event);
    },
    setFilters() {
      this.filters = {};
      var exportable = this.$refs.dt.columns.filter((c) => c.props.field);
      for (var i = 0; i < exportable.length; i++) {
        var filterValue = null;
        if (this.stateFilters) {
          var field = this.stateFilters[exportable[i].props.field];
          if (field) filterValue = field.value;
        }
        this.filters[exportable[i].props.field] = {
          value: filterValue,
          matchMode: "contains",
        };
      }
    },
    clearFilter() {
      this.filters = {};
      var exportable = this.$refs.dt.columns.filter((c) => c.props.field);
      for (var i = 0; i < exportable.length; i++) {
        var fieldName = exportable[i].props.field;
        var filterValue = "";
        if (fieldName.includes("Date")) {
          filterValue = null;
        }
        this.filters[exportable[i].props.field] = {
          value: filterValue,
          matchMode: "contains",
        };
      }
      this.onShowModal();
    },
    onStateRestore(event) {
      this.start = event.first;
      this.stateFilters = event.filters;
      this.sorts = event.multiSortMeta;
    },
  },
  mounted() {
    // Watch for changes in loadedData
    watch(
      () => this.dataModel,
      (newValue, oldValue) => {
        if (newValue !== oldValue && !this.methodExecuted) {
          // Data has changed, execute your method
          this.setFilters();
          this.methodExecuted = true;
        }
      }
    );
  },
  computed: {
    assignEditDriverModel() {
      return { driverModel: this.driverModel, driverModels: this.driverModels };
    },
    dataFilter() {
      var h = [];
      if (this.filters) {
        for (const [key, value] of Object.entries(this.filters)) {
          h.push({
            field: key ? key : null,
            value: value.value,
            matchMode: value.matchMode,
          });
        }
      }
      return h;
    },
    filterBadge() {
      var badgeNumber = 0;

      this.dataFilter.filter(function (item) {
        if (item.value && item.field != "Status") {
          badgeNumber++;
        }
      });

      return badgeNumber;
    },
    dataSort() {
      var h = [];
      if (this.sorts) {
        for (var x = 0; x < this.sorts.length; x++) {
          h.push({
            field: this.sorts[x].field,
            order: this.sorts[x].order == 1 ? "ASC" : "DESC",
          });
        }
      }
      return h;
    },
  },
};
</script>

<style #scoped>
.p-card .p-card-content {
  margin: 0 !important;
  padding: 0 !important;
}
</style>
